import type {Context} from '../types';
import {fixDataTypeJson} from '@packages/systems/core/component-migrations';
import {
  isSymbolRoot,
  isSymbolInst,
} from '@packages/systems/core/utils/DomTypeUtils';
import type {JSONNode} from '@packages/shared/types/JSONNode';
import {Type} from '@packages/systems/wfdl';

const hasDataType = (jsonNode: JSONNode) =>
  isSymbolRoot(jsonNode.data) && Boolean(jsonNode.dataType);

const hasInstDataType = (jsonNode: JSONNode) =>
  isSymbolInst(jsonNode.data) && Boolean(jsonNode.data?.sym.instDataType);

const parseIfString = (value: string | Type) =>
  typeof value === 'string' ? JSON.parse(value) : {...value};

export default (context: Context) => {
  const {
    node: {jsonNode},
  } = context;

  let fixedDataType: string | undefined | Type;
  let fixedInstDataType: string | undefined | Type;

  let fixedDataTypeisNeeded = false;
  let fixedInstDataTypeisNeeded = false;

  if (jsonNode.dataType && hasDataType(jsonNode)) {
    const dataTypeShallowCopy = parseIfString(jsonNode.dataType);

    fixedDataType = JSON.stringify(fixDataTypeJson(dataTypeShallowCopy));

    fixedDataTypeisNeeded = fixedDataType !== jsonNode.dataType;
  }

  if (jsonNode?.data && hasInstDataType(jsonNode)) {
    const dataTypeInstShallowCopy = parseIfString(
      jsonNode.data.sym.instDataType
    );

    fixedInstDataType = JSON.stringify(
      fixDataTypeJson(dataTypeInstShallowCopy)
    );

    fixedInstDataTypeisNeeded =
      fixedInstDataType !== jsonNode.data.sym.instDataType;
  }

  return {
    needed: fixedDataTypeisNeeded || fixedInstDataTypeisNeeded,
    logData: {
      msg: 'Components need to have `fixDataTypeJson` applied',
      meta: {
        nodeId: jsonNode._id,
      },
    },
    apply: () => {
      if (hasDataType(jsonNode) && fixedDataTypeisNeeded) {
        jsonNode.dataType = fixedDataType;
      }

      if (
        jsonNode.data &&
        hasInstDataType(jsonNode) &&
        fixedInstDataTypeisNeeded
      ) {
        jsonNode.data.sym.instDataType = fixedInstDataType;
      }
    },
  };
};
